import {Board, BoardHeader, BoardTableContainer} from "../../assets/GlobalStyles";
import React, {useCallback, useEffect, useState} from "react";
import {useAtom} from "jotai";
import Table from "../../components/table";
import {accountDataColumns, accountDataSetting, accountHistoryDataAtom, searchAccountParams} from "./entity";
import {accountCreateInvoiceRecord, accountHistoryTableData} from "../../services/account/AccountAdminAxios";
import {SearchUser} from "../../components/common/SearchUser";
import {AdminInfo} from "../layout";
import {confirmAlert} from "react-confirm-alert";
import {AccountCondition} from "../../components/Account/Condition";

export function reactConfirmClose() {
  const target = document.getElementById('react-confirm-alert');
  if(!target) return false
  const svg = document.getElementById('react-confirm-alert-firm-svg');
  if(!svg) return false
  target.parentNode.removeChild(target);
  svg.parentNode.removeChild(svg);
  const root = document.body.children[0];
  root.classList.remove('react-confirm-alert-blur');
  return true
}

export default function AccountData() {
  const [adminInfoState] = useAtom(AdminInfo) //매체 전환 계정 정보
  const [accountHistoryDataState, setAccountHistoryDataState] = useAtom(accountHistoryDataAtom)
  const [searchAccountHistoryParamsState, setSearchAccountHistoryParamsState] = useState(searchAccountParams)

  const handleHistoryTableData = useCallback(async () => {
    const userName = adminInfoState.convertedUser !== ''
        ? adminInfoState.convertedUser
        : '';

    const fetchData = await accountHistoryTableData(
        userName,
        searchAccountHistoryParamsState
    ).then(response => {
      if (response !== null) {
        setAccountHistoryDataState(response);
      }

      return response;
    });

    return fetchData;
  }, [
    adminInfoState.convertedUser,
    searchAccountHistoryParamsState,
    setAccountHistoryDataState,
  ]);

  useEffect(() => {
    handleHistoryTableData();

    return () => {
      reactConfirmClose();
    };
  }, [handleHistoryTableData]);;


  /**
   * 모달안에 매체 검색 선택시
   */
  const handleHistoryAdd = (params) => {
    accountCreateInvoiceRecord(params).then(response => {
      response ? handleHistoryTableData() : confirmAlert({
        title: '이력 추가',
        message: '정산 프로필이 없습니다.',
        buttons: [
          {
            label: '확인',
          }
        ]
      });
    })
  }

  return (
    <>
      <Board>
        <BoardHeader>데이터 관리</BoardHeader>
        <AccountCondition searchAccount={searchAccountHistoryParamsState} setSearchAccount={setSearchAccountHistoryParamsState} handleHistoryTableData={handleHistoryTableData}/>
        <BoardTableContainer>
          <div style={{display: 'flex', justifyContent: 'flex-end'}}><SearchUser title={'이력 추가'} className={'listUp'} onSubmit={handleHistoryAdd} btnStyle={'historyAddButton'} historyAdd={true}/></div>
          <Table columns={accountDataColumns}
                 data={accountHistoryDataState}
                 emptyText={'정산 데이터 관리 내역이 없습니다.'}
                 settings={accountDataSetting}
          />
        </BoardTableContainer>
      </Board>
    </>
  )
}
